import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import {Router,ActivatedRoute} from "@angular/router"
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';

import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';

import {AuthService} from '../../auth/auth.service';
import {Subscription,Subject} from 'rxjs';
import { takeUntil } from 'rxjs/operators';

///IDIOMAS
import { lang_login } from 'app/idiomas/i18n/login/login.lang';
import { lang_idiomas } from 'app/idiomas/i18n/idiomas/idiomas.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

import { TranslateService } from '@ngx-translate/core';
import *  as $ from 'jquery';
import Swal from 'sweetalert2';

import { DATOS_API } from 'app/auth/auth.datos';
import * as configuracion from 'app/configuracion/login';

import { LoginService } from "./login.service";

const momentTz = require('moment-timezone');
import * as catalogos from "./login.catalogos";

import { AutenticacionComponent } from "./autenticacion/autenticacion.component";
import {Base64} from 'js-base64';
@Component({
  selector     : 'login',
  templateUrl  : './login.component.html',
  styleUrls    : ['./login.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations   : fuseAnimations
})
export class LoginComponent implements OnInit, OnDestroy
{
  private authListenerSubs: Subscription;
  private _unsubscribeAll: Subject<any>;
  fuseConfig: any;
  form = this._formBuilder.group({
    colorTheme      : new FormControl(),
    customScrollbars: new FormControl(),
    layout          : this._formBuilder.group({
      style    : new FormControl(),
      width    : new FormControl(),
      navbar   : this._formBuilder.group({
        primaryBackground  : new FormControl(),
        secondaryBackground: new FormControl(),
        folded             : new FormControl(),
        hidden             : new FormControl(),
        position           : new FormControl(),
        variant            : new FormControl()
      }),
      toolbar  : this._formBuilder.group({
        background           : new FormControl(),
        customBackgroundColor: new FormControl(),
        hidden               : new FormControl(),
        position             : new FormControl()
      }),
      footer   : this._formBuilder.group({
        background           : new FormControl(),
        customBackgroundColor: new FormControl(),
        hidden               : new FormControl(),
        position             : new FormControl()
      }),
      sidepanel: this._formBuilder.group({
        hidden  : new FormControl(),
        position: new FormControl()
      })
    })
  });
  loginForm: FormGroup;
  userIsAuthenticated = false;
  datosLogin:any;
  detectorDispositivo:any;
  detectorNavegador: any;
  languages = catalogos.idiomas;
  selectedLanguage: any;

  isLoading = false;

  parametroTema: string;
  temasDisponibles = catalogos.temasDisponibles
  parametroMantenimiento: string;

  // urlAssets = DATOS_API.urlAssets;
  urlAssets: string = '';
  // configLogin: any;
  configLogin = configuracion.loginCGO;
  hide = true;

  jsonsConfiguracion: any = {};
  intervaloBg: any;
  contenidoExterno = false;
  urlSafe: SafeResourceUrl;
  infoVideo = {
    enable: false,
    video: '',
    loop: false,
    mute: false
  };

  brokersEspeciales = catalogos.brokersEspeciales;
  dominiosEspeciales = catalogos.dominiosEspeciales;
  emailDemo="";
  passDemo="";
  regexEmpresa = new RegExp("^[a-zA-Z0-9 ÁÉÍÓÚÜáéíóúüñÑ@.,_-]*$");
  regexEmpresa2 = new RegExp("^[a-zA-Z0-9 ÁÉÍÓÚÜáéíóúüñÑ@.´'|;_}{+-]*$");
  caracteresNoPermitidosEmpresa=false;
  mrtopEmail="5px";
  emailCorrect:boolean=false;
  passCorrect:boolean=false;
  correoValido:any[]=[
    {'emailOk':false,},
    {'caratOk':false},
  ]
  emailValidadoCorrectamente:boolean=false;
  passValidadoCorrectamente:boolean=false;
  urlSafeLanding: SafeResourceUrl;
  landing= false;
  informacion = 'Información desde el componente padre';
  enviarInfo=false;
  constructor(
    private _fuseConfigService: FuseConfigService,
    private _formBuilder: FormBuilder,
    public authService: AuthService,
    private router: Router,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private _translateService: TranslateService,
    private activatedRoute: ActivatedRoute,
    private loginService: LoginService,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog,
  )
  {
    lang_login.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_idiomas.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_modales.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    // Configure the layout
    this._fuseConfigService.config = catalogos.fuseConfig;
    this._unsubscribeAll = new Subject();

    this.activatedRoute.queryParams.subscribe(params => {
      //console.log(params);
      this.parametroTema = params['id'];
      this.parametroMantenimiento = params['tenim'];
    });

    this.bypassMantenimiento();

    localStorage.removeItem("institutoValidacionEtiquetas");
    localStorage.removeItem("customConfig");
    const d = document, n = navigator, ua =  n.userAgent;
    this.detectorDispositivof(ua);
    this.detectorNavegadorf(ua);
// this.cambioGifBroker('spinnerCGO',`background-image: url(https://www.educaciontrespuntocero.com/wp-content/uploads/2019/06/homer.gif)!important;width: 100px;height: 60px;background-size: contain;background-position: center;background-repeat: no-repeat;`);
  }

  ngOnInit(): void
  {
//     // setTimeout(() => {
//       let elements = document.querySelectorAll('[autocomplete="off"]');
//       elements.forEach(element => {
//         console.log('element',element);
//
//     element.setAttribute("readonly", "readonly");
//     // element.style.backgroundColor = "inherit";
//     setTimeout(() => {
//         element.removeAttribute("readonly");
//     }, 500);
// })
      // console.log("entro este visne perron ");
      //
      // $(document).ready(function() {
      //   $("#email").attr('autocomplete', 'off');
      // });

    // }, 6000);
    //activar si hay un modal que mostrar
    // this.modalAvisos();
    this.userIsAuthenticated = this.authService.getIsAuth();
    this.redirLogin();

    this.authListenerSubs = this.authService.getAuthStatusListener().subscribe(isAuthenticated => {
      // console.log("es autenticado: "+isAuthenticated);
      this.userIsAuthenticated = isAuthenticated.status;
      this.isLoading = false;
      if(isAuthenticated.mensaje && isAuthenticated.mensaje == 'tokenVersion'){
        this.isLoading = true;
        Swal.fire({
          title: this._translateService.instant('MODALES.ERRORES.tokenActLogin'),
          icon: 'error',
          confirmButtonText: this._translateService.instant('MODALES.ACCIONES.aceptar'),
          confirmButtonColor: '#ff8f00',
          allowOutsideClick: false
        }).then((result) => {
          if (result.value) {
            window.location.reload();
            localStorage.removeItem('tokenVersion');
          }
        });
      }
    });

    this.loginForm = this._formBuilder.group({
      email   : ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });

    //this.selectedLanguage = _.find(this.languages, {id: });
    let langAct = this._translateService.currentLang;
    this.setLanguage(langAct);


    /// PRUEBAS CAMBIO TEMA
    this._fuseConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe((config) => {
      console.log("se envio cambio al config:",config);

      // Update the stored config
      this.fuseConfig = config;
      // Set the config form values without emitting an event
      // so that we don't end up with an infinite loop
      this.form.setValue(config, {emitEvent: false});
    });
    this.form.valueChanges.pipe(takeUntil(this._unsubscribeAll)).subscribe((config) => {
      // Update the config
      console.log("cambiara tema:",config);
      this._fuseConfigService.config = config;
    });
    this.deteccionPais();

    setTimeout(() => {
      this.validacionFormulario();
    }, 100);
  }

  bypassMantenimiento(){
    if(!this.parametroMantenimiento){
      //consulta el status de la plataforma, si está en mantenimiendo u operando
      this.authService.getMantenimiento().subscribe((respuesta:any) => {
        if(respuesta.message == 'Success'){
          if(respuesta.status){
            this.router.navigate(['/maintenance']);
          }
        }
      });
    }
  }

  //
  detectorDispositivof(ua){
    let tipoDispositvo={
      android:()=> ua.match(/android/i),
      ios:()=> ua.match(/iphone|ipad|ipod/i),
      windowsphone:()=> ua.match(/windows phone/i),
      linux:()=>ua.match(/linux/i),
      windows:()=>ua.match(/windows nt/i),
      mac:()=>ua.match(/mac os/i),
      any:function(){
        return this.android() ||this.ios() ||this.ios() ||this.linux()||this.windows()||this.mac();
      }
    }
    this.detectorDispositivo=tipoDispositvo.any();
    console.log("tipoDispositvo",this.detectorDispositivo);
  }

  detectorNavegadorf(ua){
    let tipoNavegador={
      chrome:()=> ua.match(/chrome/i),
      safari:()=> ua.match(/safari/i),
      firefox:()=> ua.match(/firefox/i),
      opera:()=>ua.match(/opera/i),
      ie:()=>ua.match(/msie|iemobile/i),
      edge:()=>ua.match(/edge/i),
      any:function(){
        return this.chrome() ||this.safari() ||this.firefox() ||this.opera()||this.ie()||this.edge();
      }
    }
    console.log("tipoNavegador",tipoNavegador.any());
    this.detectorNavegador=tipoNavegador.any();
    console.log("tipoNavegador",this.detectorNavegador);
  }

  iniciaSesion(){
    this.datosLogin={
      systemOpe: this.detectorDispositivo[0],
      ipPublica: localStorage.getItem('ip_Publica'),
      navegador:this.detectorNavegador[0],
      resolucion:localStorage.getItem('resolucion'),
    }
    console.log('datosLogin: ',this.datosLogin);
    this.isLoading = true;
    this.authService.loginUser(this.loginForm.value.email,this.loginForm.value.password,this.detectorDispositivo[0],this.detectorNavegador[0]);
  }

  mostrarPassword(e?){
    e.preventDefault();
  }
  redirLogin(){
    if(this.authService.getIsAuth()){
      this.router.navigate(['/home']);
    }
  }



  colocaBackground(datosConfig?:any){
    $(document).ready(() => {
      let iterImg = 0;
      let imagenes = [];
      // let tiempoEspera = 5000;  //ms de espera entre transiciones de imagenes
      let tiempoEspera = datosConfig != undefined ? datosConfig.tiempoEspera : 5000;  //ms de espera entre transiciones de imagenes
      if(!datosConfig){
        this.configLogin.imagenes.forEach(imagen => {
          for(let i=1; i<=imagen.imagenes; i++){
            if(i < 10){ //imagenes del 001 al 009
              imagenes.push(this.urlAssets + imagen.carpeta + "00" + i + ".jpg");
            }
            else{     //imagenes del 010 en adelante
              imagenes.push(this.urlAssets + imagen.carpeta + "0" + i + ".jpg");
            }
          }
        });
      } else{
        datosConfig.arrImagenes.forEach(imagen => {
          imagenes.push(imagen.image);
        });
      }
      imagenes.sort((a, b) => { return 0.5 - Math.random() });

      //si esta activo el tema de izzi se hace ahi algo raro para que se ponga una primera imagen igual siempre
      if(localStorage.getItem('tipoBroker')){
        switch (localStorage.getItem('tipoBroker')) {
          case 'wqKgj6X':   //este caso es el del tema izzi
          let nombrePrimeraImagen = imagenes[imagenes.findIndex(item => item.includes("001"))];
          imagenes[imagenes.findIndex(item => item.includes("001"))] = imagenes[0];
          imagenes[0] = nombrePrimeraImagen;
          tiempoEspera = 10000;
          break;
        }
      }
      let image = $('#bgImg');
      image.html('');
      imagenes.forEach((imagen) => {
        image.append('<img src="' + imagen + '">');
      });

      let imagenesCargadas = image.children();
      $(imagenesCargadas[0]).fadeIn(1000);

      clearInterval(this.intervaloBg);

      this.intervaloBg = setInterval(function(){
        $(imagenesCargadas[iterImg]).fadeOut(1000, function () {
          iterImg++;
          if(iterImg == imagenesCargadas.length){
            iterImg = 0;
          }
          $(imagenesCargadas[iterImg]).fadeIn(1000);
          //restablece a 5000ms el tiepo de espera entre imagenes, si es que se modificó antes
          // tiempoEspera = 5000;
        });

      }, tiempoEspera);
    });
  }

  setLanguage(lang): void
  {
    // console.log(lang);
    // Set the selected language for the toolbar
    this.selectedLanguage = lang;

    // Use the selected language for translations
    this._translateService.use(lang);
    // this._translateService.use(lang.id);
    if(localStorage.getItem('customConfig')){
      this.cambioIdiomaConfiguracion(this._translateService.currentLang,2);
    }
  }

  modalAvisos(permanente?:boolean){
    let titulo:string;
    let texto:string;
    this._translateService.get('LOGIN.MODALES.AVISO1.TITULO').subscribe((res: string) => { titulo = res; });
    this._translateService.get('LOGIN.MODALES.AVISO1.TEXTO').subscribe((res: string) => { texto = res; });
    Swal.fire({
      title: titulo,
      html: texto,
      icon: 'info',
      showConfirmButton: permanente != undefined ? false : true,
      confirmButtonColor: '#ff8f00',
      allowOutsideClick: false,
      width: '50%',
      customClass: {
        htmlContainer: 'contenidoModal'
      }
    });

  }

  detectaBrokerEspecial(){
    let numInstituto: number;
    let indiceBroker: number;
    this.urlAssets = DATOS_API.urlAssets;
    if(this.parametroTema){
      indiceBroker = this.brokersEspeciales.findIndex(item => item.urlParam == this.parametroTema);
      numInstituto = this.brokersEspeciales[indiceBroker].numInstituto;
      if(!localStorage.getItem('tipoBroker')){
        localStorage.setItem('tipoBroker', this.parametroTema);
        this.form.controls['colorTheme'].setValue(this.brokersEspeciales[indiceBroker].tema);
        this.configLogin = configuracion[this.brokersEspeciales[indiceBroker].config.login];
      }
    }
    else{
      if(localStorage.getItem('tipoBroker')){
        indiceBroker = this.brokersEspeciales.findIndex(item => item.urlParam == localStorage.getItem('tipoBroker'));
        numInstituto = this.brokersEspeciales[indiceBroker].numInstituto;
        this.form.controls['colorTheme'].setValue(this.brokersEspeciales[indiceBroker].tema);
        this.configLogin = configuracion[this.brokersEspeciales[indiceBroker].config.login];
      } else{
        // this.form.controls['colorTheme'].setValue('temaFocusArea2');
      }
    }
    return numInstituto;
  }

  detectaDominioEspecial(soloGet?:boolean){
    let [dominio] = (window.location.href).split('#');
    let dominioEncontrado: any;
    let numBroker: number;
    let BreakException = {};
    try {
      this.dominiosEspeciales.forEach(domEsp => {
        if(dominio.includes(domEsp.dominio)){
          dominioEncontrado = domEsp;
          throw BreakException;
        }
      });
    } catch (e) {
      if (e !== BreakException) throw e;
    };
    if(!soloGet){
      if(dominioEncontrado){
        console.log("dominio coincidente:",dominioEncontrado);
        this.form.controls['colorTheme'].setValue(dominioEncontrado.tema);
        this.configLogin = configuracion[dominioEncontrado.config.login];
      } else{
        console.log("no se encontro dominio especial, actual:",dominio);
      }
    } else{
      if(dominioEncontrado){
        numBroker = dominioEncontrado.numInstituto != undefined ? dominioEncontrado.numInstituto : undefined;
      }
    }
    return numBroker;
  }

  deteccionPais(){
    let zonaActual = momentTz.tz.guess();

    this.loginService.getInstitutos().subscribe((institutos:any) => {
      let brokers = institutos.Institutos;
      let brokerActual: number = 0;
      let BreakException = {};
      try {
        brokers.forEach(broker => {
          broker.paises.forEach(pais => {
            let zonas = momentTz.tz.zonesForCountry(pais.pais);
            // console.log(`zonas de ${pais}:`,zonas);
            if(zonas.includes(zonaActual)){
              console.log("pais encontrado:",pais.pais," broker:",broker.regionInstituto);
              brokerActual = broker.numInstituto;
              throw BreakException;
            }
          });
        });
      } catch (e) {
          if (e !== BreakException) throw e;
      };
      /// revisa con el parametro en la url si el broker es especial (izzi o gcti), si lo es se toma el numero de instituto especifico
      // esto es porque ni izzi ni gcti son paises especificos y se accede a ellos a traves de un parametro
      let brokerEspecial = this.detectaBrokerEspecial();
      console.log("brokEsp:",brokerEspecial);
      if(brokerEspecial != undefined){
        brokerActual = brokerEspecial;
      }
      let brokerDominio = this.detectaDominioEspecial(true);
      console.log("brokDom:",brokerDominio);
      if(brokerDominio != undefined){
        brokerActual = brokerDominio;
      }
      //guarda una variable temporal en localStorage
      localStorage.setItem('tmpBroker',brokerActual.toString());
      if(brokerActual != 0){
        this.loginService.getFlag(brokerActual).subscribe((respuesta:any) => {
          console.log("getFlagLogin:",respuesta);
          if(respuesta.success){
            if(respuesta.flagStatus.flag){
              // this.configuraDominioBackend(respuesta.flagStatus.domain); //DESCOMENTAR PARA QUE TOME LA URL DE BACKEND CUSTOM
              this.urlAssets = '';
              this.loginService.getJsons(brokerActual).subscribe((respuesta:any) => {
                console.log("getJsonsLogin:",respuesta);
                if(respuesta.success){
                  respuesta.jsonCGO.forEach(json => {
                    if(!this.jsonsConfiguracion[json.lang]){
                      this.jsonsConfiguracion[json.lang] = json;
                    }
                  });
                  this.cambioIdiomaConfiguracion(this._translateService.currentLang,1);
                  if(!localStorage.getItem('customConfig')){
                    localStorage.setItem('customConfig',"true");
                  }
                }
              });
            } else{
              this.urlAssets = DATOS_API.urlAssets;
              this.detectaDominioEspecial();
              this.colocaBackground();
              localStorage.setItem('urlGifBroker','https://app04.culturalgo.com/assetsCGO5/platform/img/loading.gif');
            }
          }
        });
      }
    });
  }

  configuraDominioBackend(dominio:any){
    if(dominio.enable){
      localStorage.setItem('customDom',dominio.url);
    } else{
      localStorage.removeItem('customDom');
    }
  }

  cambioIdiomaConfiguracion(idioma:string, via:number){
    console.log("cambioConfIdioma, via:",via);

    console.log("cambioidioma:",idioma);
    console.log("jsons:",this.jsonsConfiguracion);
    let referenciaJson = this.jsonsConfiguracion[idioma].login;
    let referenciahome = this.jsonsConfiguracion[idioma].home;
    let datos = {
      tiempoEspera: referenciaJson.generics.changeTime,
      arrImagenes: referenciaJson.backgrounds
    };
    this.colocaBackground(datos);
    ///configuracion de otros assets
    this.configLogin.logoBroker = referenciaJson.generics.images.broker;
    this.configLogin.logoLogin = referenciaJson.generics.images.login;
    this.configLogin.logoLogout = referenciaJson.generics.images.logout;
    this.configLogin.titulo = referenciaJson.generics.title;
    this.contenidoExterno = referenciaJson.generics.externalContent.enable;
    this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(referenciaJson.generics.externalContent.url);
    this.infoVideo = referenciaJson.generics.videoBackground;
    if (referenciahome.loaderGif.image!="") {
      // DATOS_API.urlGifDefault=referenciahome.generics.loaderGif.image;
      localStorage.setItem('urlGifBroker',referenciahome.loaderGif.image);
    }else{
      localStorage.setItem('urlGifBroker','https://app04.culturalgo.com/assetsCGO5/platform/img/loading.gif');
    }

    this.cambiaTema(idioma);
  }

//   cambioGifBroker(className, classValue){
// console.log('cambio gif ');
//
//       // we need invisible container to store additional css definitions
//       var cssMainContainer = $('#css-modifier-container');
//       if (cssMainContainer.length == 0) {
//           var cssMainContainer = $('<div id="css-modifier-container"></div>');
//           cssMainContainer.hide();
//           cssMainContainer.appendTo($('body'));
//       }
//
//       // and we need one div for each class
//       var classContainer = cssMainContainer.find('div[data-class="' + className + '"]');
//       if (classContainer.length == 0) {
//           classContainer = $('<div data-class="' + className + '"></div>');
//           classContainer.appendTo(cssMainContainer);
//       }
//
//       // append additional style
//       classContainer.html('<style type="text/css">' + className + ' {' + classValue + '}</style>');
//   }
  cambiaTema(idioma:string){
    let referenciaJson = this.jsonsConfiguracion[idioma].home;
    if(referenciaJson.generics.theme != ""){
      this.form.controls['colorTheme'].setValue(referenciaJson.generics.theme);
    }
  }

  ngOnDestroy()
  {
    this.authListenerSubs.unsubscribe();
  }
  goPassword(){
    this.router.navigate(['password']);
  }

  login2FA_paso1(){
    this.isLoading = true;
    const authData = {
      user: this.loginForm.controls['email'].value,
      password: this.loginForm.controls['password'].value,
      device: this.detectorDispositivo[0],
      browser: this.detectorNavegador[0],
      screenResolution: window.screen.width+ ' x '+ window.screen.height,
    };
    this.loginService.loginV2(authData).subscribe((respuesta:any) => {
      console.log("loginV2:",respuesta);
      if(respuesta.succes){ //codigo qr
        this.login2FA_paso2(respuesta.ascii, respuesta.qrCodeGenerate, authData.user, authData.password, respuesta.codeActive);
      } else if(respuesta.success){
        // console.log("entro este visne del login");
        // let img= Base64.encode('https://personalprojekte.com/wp-content/uploads/2020/07/ki-human-resources.jpeg');
        // let url="/loading"
        // this.router.navigate([url,img]);
        this.authService.login2FA_paso3(respuesta);
      }else if(respuesta.success==false){
        if (respuesta.message=="300") {
          Swal.fire({
            title: this._translateService.instant('MODALES.ERRORES.300'),
            icon: 'error',
            // showConfirmButton: permanente != undefined ? false : true,
            confirmButtonColor: '#ff8f00',
            confirmButtonText: this._translateService.instant('MODALES.ACCIONES.aceptar'),
            allowOutsideClick: false,
            width: '50%',
            customClass: {
              htmlContainer: 'contenidoModal'
            }
          });
          this.isLoading = false;
        }
      }
    }, error => {
      console.log("ocurrio un error: ",error);
      this.isLoading = false;
    });
  }

  login2FA_paso2(ascii:string, qr:string, user:string, password:string, codeActive:string){
    const dialogRef = this.dialog.open(AutenticacionComponent, {
      width: '50%',
      disableClose: true,
      data: {
        ascii,
        qr,
        user,
        password,
        codeActive
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log("result:",result);
      if(result == undefined){
        this.isLoading = false;
      }
    });
  }

  validacionFormulario(){
    const emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
    const regexEmpresa = new RegExp("^[a-zA-Z0-9 ÁÉÍÓÚÜáéíóúüñÑ@.,_-]*$");
    const emailActual = this.loginForm.controls['email'].value;
    const passActual = this.loginForm.controls['password'].value;
    console.log("correo:",emailActual);
    console.log("pass:",passActual);

    let paso_1: boolean = true;
    let paso_2: boolean = true;

    /// VALIDACION DE CORREO
    if (emailRegex.test(emailActual)){
      console.log("correo valido");
    } else {
      console.log("correo invalido");
      paso_1 = false;
    }
    // VALIDACION DE CARACTERES ESPECIALES
    if(this.regexEmpresa.test(emailActual)){
      this.caracteresNoPermitidosEmpresa = false;
      this.mrtopEmail="5px";
    } else{
      this.caracteresNoPermitidosEmpresa = true;
      this.mrtopEmail="30px";
      paso_2 = false;
    }
    if(paso_1 && paso_2){
      this.emailValidadoCorrectamente = true;
    } else{
      this.emailValidadoCorrectamente = false;
    }

    // VALIDACION DE CONTRASEÑA
    if(passActual.length > 0){
      this.passValidadoCorrectamente = true;
    } else{
      this.passValidadoCorrectamente = false;
    }
  }

  validacionCaracEmail(email){
    console.log('this.email',email.target.value);
    console.log('this.email v3',this.loginForm.value.email.length);
    let emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
    if (emailRegex.test(email.target.value)){
   console.log("La dirección de email " + email.target.value + " es correcta.");
        this.correoValido[0].emailOk=true;
  } else {
    console.log("La dirección de email es incorrecta.");
    this.correoValido[0].emailOk=false;
    // this.reglasEmail[1].tipoEmai=false;
    }

    if(this.validarCadenaEmpresa(email.target.value)) {
      console.log("aqui entra bien chido");
      this.caracteresNoPermitidosEmpresa=false;
      this.mrtopEmail="5px";
        this.correoValido[1].caratOk=true;
      // this.reglasEmail[0].caracOk=true;

    }else{
      this.caracteresNoPermitidosEmpresa=true;
      console.log("no esta bien");
      this.mrtopEmail="30px";
      this.correoValido[1].caratOk=false;
      // console.log(this.caracteresNoPermitidosEmpresa);
      // this.reglasEmail[0].caracOk=false;
    }


    if (this.correoValido[0].emailOk && this.correoValido[1].caratOk) {
      this.emailValidadoCorrectamente=true;

    }else{
      this.emailValidadoCorrectamente=false;
    }
    console.log('emailValidadoCorrectamente',this.emailValidadoCorrectamente);

  }
  validarCadenaEmpresa(cadena:any){
    console.log("entro" );

    return this.regexEmpresa.test(cadena);
  }
validacionPassEmail(pass){
  if (pass.target.value.length>0){
  this.passValidadoCorrectamente=true;
} else {
  this.passValidadoCorrectamente=false;

  }
}

}
